import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { STORYBLOK_BFF_URL } from "../../util/api";
import { acceptedLinkStarts } from "./schema";
export var getLinks = function() {
    var _ref = _async_to_generator(function(startsWith) {
        var linksToPull, rawParams, params, url, response, data, ref, e;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    linksToPull = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 10;
                    startsWith = acceptedLinkStarts.parse(startsWith);
                    rawParams = {
                        cv: Date.now().toString(),
                        version: "published"
                    };
                    if (startsWith) {
                        rawParams["starts_with"] = startsWith;
                    }
                    if (linksToPull) {
                        rawParams["per_page"] = linksToPull.toString();
                    }
                    params = new URLSearchParams(rawParams);
                    url = "".concat(STORYBLOK_BFF_URL, "/get-links?").concat(params.toString());
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch(url)
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    data = _state.sent();
                    if (Object.keys((ref = data === null || data === void 0 ? void 0 : data.links) !== null && ref !== void 0 ? ref : {}).length === 0) return [
                        2,
                        {}
                    ];
                    return [
                        2,
                        data.links
                    ];
                case 4:
                    e = _state.sent();
                    throw new Error("links endpoint not working");
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function getLinks(startsWith) {
        return _ref.apply(this, arguments);
    };
}();
